import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", company: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/contact", f);
      setSent(true);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <main className="mx-auto grid max-w-6xl gap-12 px-5 py-20 lg:grid-cols-2 lg:px-8">
      <div>
        <p className="eyebrow">Contact</p>
        <h1 className="mt-3 text-4xl font-bold text-white sm:text-5xl">Talk to the Saflr team</h1>
        <p className="mt-5 text-slate-400">Questions about plans, enterprise requirements or getting started? Send us a message and we will get back to you.</p>
      </div>
      {sent ? (
        <div data-testid="contact-success" className="rounded-3xl border border-health/40 bg-health/10 p-10 text-white"><h2 className="text-2xl font-semibold">Thanks — message received.</h2><p className="mt-2 text-slate-300">We'll reply to {f.email} as soon as possible.</p></div>
      ) : (
        <form onSubmit={submit} className="space-y-4 rounded-3xl border border-white/10 bg-white/[0.02] p-8">
          <div className="grid gap-4 sm:grid-cols-2">
            <Input required placeholder="Name" value={f.name} onChange={set("name")} data-testid="contact-name" />
            <Input required type="email" placeholder="Email" value={f.email} onChange={set("email")} data-testid="contact-email" />
          </div>
          <Input placeholder="Company" value={f.company} onChange={set("company")} data-testid="contact-company" />
          <Input required placeholder="Subject" value={f.subject} onChange={set("subject")} data-testid="contact-subject" />
          <Textarea required rows={6} placeholder="How can we help?" value={f.message} onChange={set("message")} data-testid="contact-message" />
          <Button type="submit" className="w-full rounded-full" data-testid="contact-submit">Send message</Button>
        </form>
      )}
    </main>
  );
}
